import { SYSTEM_SUBPAGES } from './systemSubpages';

const titles = {
  'systems/temp-voice': ['الغرف الصوتية المؤقتة', 'Temp Voice'],
  profile: ['صفحة المستخدم', 'User Profile'],
  servers: ['خوادمي', 'My Servers'],
  subscription: ['الاشتراك', 'Subscription'],
  billing: ['الفواتير', 'Billing'],
  support: ['الدعم', 'Support'],
  'server-overview': ['نظرة عامة على الخادم', 'Server Overview'],
  'xp-overview': ['نظرة عامة على XP', 'XP Overview'],
  leaderboard: ['المتصدرون', 'Leaderboard'],
  embeds: ['الرسائل', 'Messages'],
  'server-settings': ['إعدادات الخادم', 'Server Settings'],
  'admin-roles': ['صلاحيات المشرفين', 'Admin Roles'],
  'systems/level': ['نظام المستويات', 'Level System'],
  'systems/welcome': ['نظام الترحيب', 'Welcome System'],
  'systems/automod': ['أنظمة الرقابة', 'Moderation Systems'],
  'systems/logs': ['نظام السجلات', 'Logs System'],
  'systems/auto-roles': ['الرولات التلقائية', 'Auto Roles'],
};

Object.values(SYSTEM_SUBPAGES).flat().forEach((page) => {
  titles[page.to.replace('/dashboard/', '')] = [page.labelAr, page.labelEn];
});

export const dashboardPageTitle = (pathContext, t) =>
  t(...(titles[pathContext.subPath || pathContext.section] || ['لوحة التحكم', 'Dashboard']));
